var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 15",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.297.549a1.1 1.1 0 0 1 .154 1.548l-9.9 12.1a1.1 1.1 0 0 1-1.73-.037l-3.3-4.4a1.1 1.1 0 0 1 1.76-1.32l2.457 3.277L13.748.703A1.1 1.1 0 0 1 15.298.55Z"
})));

export default SvgCheck;